// extracted by mini-css-extract-plugin
module.exports = {"container":"post-module--container--2zklN","content":"post-module--content--f7xx9"};